import firebase from 'firebase';
import { db } from './firebase';
// constants
import { firestoreKeys } from '../utils/constants';

// ----------------------------------------------------------------------

export default function useQuotesService() {
  const createQuote = () =>
    db.collection(firestoreKeys.QUOTES).add({
      meta: {
        createdDate: firebase.firestore.FieldValue.serverTimestamp(),
        modifiedDate: firebase.firestore.FieldValue.serverTimestamp(),
      },
    });

  const updateQuote = (quoteId, data) =>
    db
      .collection(firestoreKeys.QUOTES)
      .doc(quoteId)
      .update({
        ...data,
        'meta.modifiedDate': firebase.firestore.FieldValue.serverTimestamp(),
      });

  const getQuote = async (quoteId) => {
    try {
      const quoteDoc = await db.collection(firestoreKeys.QUOTES).doc(quoteId).get();
      if (!quoteDoc.exists) {
        throw new Error(`Quote ${quoteId} not found`);
      }
      return { id: quoteDoc.id, ...quoteDoc.data() };
    } catch (error) {
      console.error('Error getting quote:', error);
      throw error;
    }
  };

  return {
    createQuote,
    updateQuote,
    getQuote,
  };
}
